import * as S from './NavigationBar.styles';
import { Icon } from 'icon/Icon';
import { UserMenu } from '../UserMenu';

import { ROUTES } from 'enums';
import { useIntl } from 'react-intl';
import { RouteValue, RouteName } from 'types';

import { UserProfile } from '../../generated/graphql';
import { useContext } from 'react';
import { WhiteLabelContext } from 'providers/white-label/WhiteLabelProvider';

export interface NavigationBarProps {
  sideBarIsOpen: boolean;
  onToggleSideBar: () => void;
  routes: typeof ROUTES;
  activePath: RouteValue;
  onClickMenuItem: (route: RouteValue) => void;
  onClickUserProfile: () => void;
  userProfile?: Partial<UserProfile>;
}

export const NavigationBar = ({
  sideBarIsOpen,
  onToggleSideBar,
  routes,
  activePath,
  onClickMenuItem,
  onClickUserProfile,
  userProfile,
}: NavigationBarProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const { name: iconLogoName } = useContext(WhiteLabelContext);

  return (
    <S.Container>
      {activePath.length > 1 && (
        <S.SideBarButton isOpen={sideBarIsOpen} onClick={onToggleSideBar}>
          <Icon iconName="SideBarToggle" />
        </S.SideBarButton>
      )}
      <S.Logo>
        <Icon iconName={iconLogoName} width="205" />
      </S.Logo>
      <S.Menu>
        {Object.keys(routes)
          .filter((route) => route !== ROUTES.login.slice(1))
          .map((route) => (
            <S.MenuItem
              selected={routes[route as RouteName] === activePath}
              key={route}
              onClick={(): void => {
                onClickMenuItem(routes[route as RouteName]);
              }}
            >
              {formatMessage({ id: route as RouteName })}
            </S.MenuItem>
          ))}
      </S.Menu>
      <S.User>
        <UserMenu onClick={onClickUserProfile} userProfile={userProfile} />
      </S.User>
    </S.Container>
  );
};
